module.exports = __webpack_public_path__ + "media/packs/images/partners/partner-logo5-2982df16c3c6edea36c524b2ce105ef8.jpg";